import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

function Spinner({
  className,
  size = "md",
}: {
  className?: string
  size?: "sm" | "md" | "lg"
}) {
  const iconSize = { sm: "size-4", md: "size-6", lg: "size-12" }[size]
  return (
    <div className={cn("flex items-center justify-center py-8", className)}>
      <Loader2 className={cn(iconSize, "animate-spin text-muted-foreground")} />
    </div>
  )
}

export { Spinner }
